export default __webpack_public_path__ + "static/media/T-bone-contact.971a2faa.png";